import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import layout from "@/store/_layout";
import message from "@/store/_message";
import log from "@/store/_log";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "sportsbook_api";

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      platformLookUp: state.user.platformLookUp,
      gameTypeLookUp: state.user.gameTypeLookUp,
      leagueLookUp: state.user.leagueLookUp
    },
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize,
      getSportType: state.layout.sportType,
      getLeagueID: state.layout.league,
      getMatchID: state.layout.match
    }
  })
});

const cookieStorage = new VuexPersistence({
  key: storageKey,
  restoreState: (key) => Cookies.getJSON(key),
  saveState: (key, state) =>
  Cookies.set(key, state, {
    expires: 3
  }),
  reducer: state => ({
    user: {
      login: state.user.login,
      account: state.user.account,
      profile: state.user.profile,
      access: state.user.access,
      ptList: state.user.ptList,
      blList: state.user.blList,
      operatorblList: state.user.operatorblList,
      cmList: state.user.cmList,
      platform: state.user.platform,
      selectedID: state.user.selectedID,
    }
  })
});

const store = new Vuex.Store({
  modules: {
    user,
    layout,
    message,
    log
  },
  getters: {
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    dateRange: state => {
      return state.layout.dateRange;
    },
    daterange: state => {
      return state.layout.daterange;
    },
    loginID: state => {
      return state.user.login.login_id;
    },
    profileID: state => {
      return state.user.profile.profile_id;
    },
    displayName: state => {
      if(state.user.profile.full_name) {
        return state.user.profile.full_name.replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      } else {
        return null;
      }
    },
    authToken: state => {
      return state.user.login.auth_token;
    },
    isLoggedIn: state => {
      if (state.user.login.auth_token) {
        return true;
      } else {
        return false;
      }
    },
    authorityRole: state => {
      return state.user.login.authority_role;
    },
    accessRoles: state => {
      return state.user.access;
    },
    profileStatus: state => {
      return state.user.profile.status;
    },
    accountType: state => {
      return state.user.account.account_type;
    },
    securityTag: state => {
      return state.user.profile.security_tag;
    },
    accountStatus: state => {
      return state.user.account.status
    },
    accessOptions: state => {
      return state.layout.accessList;
    },
    accountID: state => {
      return state.user.account.account_id;
    },
    getCommSB: state => (group) => {
      if(state.user.cmList) {
        return state.user.cmList[0];
      }
      // if(state.user.cmList.cmSB) {
      //   return state.user.cmList.cmSB[0][group];
      // }
    },
    getCommSBPackages: state => {
      if(state.user.cmList) {
        return state.user.cmList[0].hdp_packages;
        // if(state.user.cmList.cmSB[0].hdp_packages) {
        //   let packages = state.user.cmList.cmSB[0].hdp_packages.split(",");
        //   return packages;
        // }
      }
    },
    securityDisabled: state => {
      return state.user.profile.security_disabled;
    },
    getSelectedID: state => {
      return state.user.selectedID;
    },
    getGameTypeLookUp: state => {
      return state.user.gameTypeLookUp;
    },
    getLeagueLookUp: state => {
      return state.user.leagueLookUp;
    },
    getBetLimit: state => {
      if(state.user.blList) {
        return state.user.blList;
      }
    },
    getOperatorBetLimit: state => {
      if(state.user.operatorblList) {
        return state.user.operatorblList;
      }
    },
    getPTSB: state => {
      if(state.user.ptList) {
        return state.user.ptList;
      }
      // if(state.user.ptList.ptSB) {
      //   return state.user.ptList.ptSB;
      // }
    },
    getSportType: state => {
      return state.layout.sportType;
    },
    getLeagueID: state => {
      return state.layout.league;
    },
    getMatchID: state => {
      return state.layout.match;
    },
    getPlatform: state => {
      return state.layout.platform;
    },
    getSelectedType: state => {
      return state.user.selectedType;
    },
    getBetListDetail: state => {
      return state.layout.betListDetail;
    },
    getPageDetail: state => {
      return state.layout.pageDetail;
    },
    getAccountCurrency: state => {
      return state.user.account.currency_code;
    },
    getTournamentFlag: state => {
      return state.user.account.tournament;
    },
    parentID: state => {
      return state.user.account.parent_id;
    },
    get2faValidated: state => {
      return state.user.profile['2fa_validated'];
    },
    // getCommMmo: state => (group) => {
    //   if(state.user.cmList.cmMMO) {
    //     return state.user.cmList.cmMMO[0][group];
    //   }
    // },
    // getCommMMO: state => {
    //   if(state.user.cmList.cmMMO) {
    //     return state.user.cmList.cmMMO;
    //   }
    // },
  },
  // plugins: [cookieStorage.plugin]
  plugins: [localStorage.plugin, cookieStorage.plugin]
});

export default store;
